var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg070ReplyAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.154,312.882l-125.308-125.74c-7.799-7.798-7.799-20.486-0.032-28.252L282.098,34.174 c7.828-7.793,7.856-20.456,0.063-28.284c-7.793-7.829-20.456-7.856-28.284-0.064L128.56,130.574 c-23.393,23.394-23.393,61.458-0.023,84.828l125.284,125.716c3.907,3.921,9.036,5.882,14.166,5.882 c5.107,0,10.215-1.944,14.119-5.834C289.929,333.369,289.952,320.706,282.154,312.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.154,312.882L45.846,187.142c-7.799-7.798-7.799-20.486-0.032-28.252L171.098,34.174 c7.828-7.793,7.856-20.456,0.063-28.284c-7.792-7.829-20.455-7.856-28.284-0.064L17.56,130.574 c-23.393,23.394-23.393,61.458-0.023,84.828l125.284,125.716c3.907,3.921,9.036,5.882,14.166,5.882 c5.107,0,10.215-1.944,14.119-5.834C178.929,333.369,178.952,320.706,171.154,312.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.487,153h-101.5c-11.046,0-20,8.954-20,20s8.954,20,20,20h101.5c76.921,0,139.5,62.58,139.5,139.5 S409.408,472,332.487,472c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20c98.977,0,179.5-80.523,179.5-179.5 S431.464,153,332.487,153z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg070ReplyAll);
export default __webpack_public_path__ + "static/media/070-reply-all.83acb1016e5e7ebacbe09e82c2abf873.svg";
export { ForwardRef as ReactComponent };